const pageNameKey = "bigBlueprintBannerAutoMatch";

export const bigBlueprintBannerAutoMatchEn = {
  [pageNameKey]: {
    smallOrangeText: "Tomorrow Things Exclusive",
    gradientText: "Easiest way of collecting your relevant data",
    myBlueprintLibraryButton: "My Blueprint Library",
    autoMatchBlueprintButton: "Auto Match Blueprint",
    bluePrintExampeAltText: "Blueprint Example",
    grayNotificationText: "You can restore your current structure anytime.",
    grayNotificationAltText: "Gray Lock",
    checkedList: {
      firstElement: "Hundreds of pre-configured blueprints",
      secondElement: "Applied and automatically connected in seconds",
      thirdElement: "Customize your blueprint if needed",
    },
  },
};

export const bigBlueprintBannerAutoMatchPtBr = {
  [pageNameKey]: {
    smallOrangeText: "Exclusivo Tomorrow Things",
    gradientText: "A maneira mais fácil de coletar seus dados relevantes",
    myBlueprintLibraryButton: "Minha Biblioteca de Blueprints",
    autoMatchBlueprintButton: "Modelo de Correspondência Automática",
    bluePrintExampeAltText: "Exemplo de Blueprint",
    grayNotificationText:
      "Você pode restaurar sua estrutura atual a qualquer momento.",
    grayNotificationAltText: "Cadeado cinza",
    checkedList: {
      firstElement: "Centenas de modelos pré-configurados",
      secondElement: "Aplicado e conectado automaticamente em segundos",
      thirdElement: "Personalize seu blueprint, se necessário",
    },
  },
};

export const bigBlueprintBannerAutoMatchDe = {
  [pageNameKey]: {
    smallOrangeText: "Exklusiv bei TomorrowThings",
    gradientText: "Einfachste Möglichkeit, Ihre relevanten Daten zu sammeln",
    myBlueprintLibraryButton: "Meine Blueprint-Bibliothek",
    autoMatchBlueprintButton: "Blueprint automatisch abgleichen",
    bluePrintExampeAltText: "Beispiel-Blueprint",
    grayNotificationText:
      "Sie können Ihre aktuelle Struktur jederzeit wiederherstellen.",
    grayNotificationAltText: "Graues Schloss",
    checkedList: {
      firstElement: "Hunderte vorkonfigurierter Blueprints",
      secondElement: "Angewendet und automatisch in Sekunden verbunden",
      thirdElement: "Passen Sie Ihren Blueprint bei Bedarf an",
    },
  },
};

export const bigBlueprintBannerAutoMatchZhHans = {
  [pageNameKey]: {
    smallOrangeText: "Tomorrow Things 独家",
    gradientText: "收集相关数据的最简单方法",
    myBlueprintLibraryButton: "我的蓝图库",
    autoMatchBlueprintButton: "自动匹配蓝图",
    bluePrintExampeAltText: "蓝图示例",
    grayNotificationText: "您可以随时恢复当前结构。",
    grayNotificationAltText: "灰色锁",
    checkedList: {
      firstElement: "数百个预配置的蓝图",
      secondElement: "几秒钟内应用并自动连接",
      thirdElement: "如有需要，可自定义您的蓝图",
    },
  },
};

export const bigBlueprintBannerAutoMatchIt = {
  [pageNameKey]: {
    smallOrangeText: "Esclusiva Tomorrow Things",
    gradientText:
      "Il modo più semplice per raccogliere i tuoi dati più rilevanti",
    myBlueprintLibraryButton: "La mia libreria di Blueprint",
    autoMatchBlueprintButton: "Abbinamento automatico Blueprint",
    bluePrintExampeAltText: "Esempio di Blueprint",
    grayNotificationText:
      "Puoi ripristinare la tua struttura attuale in qualsiasi momento.",
    grayNotificationAltText: "Lucchetto grigio",
    checkedList: {
      firstElement: "Centinaia di Blueprint preconfigurati",
      secondElement: "Applicato e collegato automaticamente in pochi secondi",
      thirdElement: "Personalizza il tuo Blueprint se necessario",
    },
  },
};

export const bigBlueprintBannerAutoMatchEs = {
  [pageNameKey]: {
    smallOrangeText: "Mañana Things Exclusive",
    gradientText: "La forma más fácil de recopilar tus datos relevantes",
    myBlueprintLibraryButton: "Mi biblioteca de planos",
    autoMatchBlueprintButton: "Plano de coincidencia automática",
    bluePrintExampeAltText: "Ejemplo de plano",
    grayNotificationText:
      "Puedes restaurar tu estructura actual en cualquier momento.",
    grayNotificationAltText: "Bloqueo gris",
    checkedList: {
      firstElement: "Cientos de plantillas preconfiguradas",
      secondElement: "Aplicado y conectado automáticamente en segundos",
      thirdElement: "Personaliza tu plano si es necesario",
    },
  },
};

export const bigBlueprintBannerAutoMatchNl = {
  [pageNameKey]: {
    autoMatchBlueprintButton: "Automatische blueprintmatching",
    bluePrintExampeAltText: "Voorbeeld-blueprint",
    checkedList: {
      firstElement: "Honderden vooraf geconfigureerde blueprints",
      secondElement:
        "Toegepast en automatisch binnen enkele seconden verbonden",
      thirdElement: "Pas uw blueprint indien nodig aan",
    },
    gradientText:
      "De eenvoudigste manier om uw relevante gegevens te verzamelen",
    grayNotificationAltText: "Grijs slot",
    grayNotificationText:
      "U kunt uw huidige structuur op elk moment herstellen.",
    myBlueprintLibraryButton: "Mijn blueprint-bibliotheek",
    smallOrangeText: "Exclusief van Tomorrow Things",
  },
};

export const bigBlueprintBannerAutoMatchTr = {
  [pageNameKey]: {
    autoMatchBlueprintButton: "Otomatik Eşleştirme Planı",
    bluePrintExampeAltText: "Taslak Örneği",
    checkedList: {
      firstElement: "Yüzlerce önceden yapılandırılmış plan",
      secondElement: "Saniyeler içinde uygulanır ve otomatik olarak bağlanır",
      thirdElement: "Gerekirse planınızı özelleştirin",
    },
    gradientText: "İlgili verilerinizi toplamanın en kolay yolu",
    grayNotificationAltText: "Gri Kilit",
    grayNotificationText:
      "Mevcut yapınızı istediğiniz zaman geri yükleyebilirsiniz.",
    myBlueprintLibraryButton: "Blueprint Kitaplığım",
    smallOrangeText: "Yarına Özel Şeyler",
  },
};
